export default __webpack_public_path__ + "static/media/ios.969642b4.svg";